/**
 * VendorNameLink — Iter 70i.
 *
 * Renders a vendor's business name as a clickable link to their dedicated
 * fleet page. Route: `/vendors/{public_slug}` (with `/v/{public_slug}` kept
 * as a back-compat alias). Falls back to plain text when the vendor doesn't
 * have a public_slug yet (older records or admin-created vendors that never
 * self-slugged) so we never render a broken link.
 *
 * Props:
 *   vendor       — { public_slug, business_name, name }
 *   className    — Tailwind classes for the visible text
 *   testIdSuffix — appended to `vendor-name-link-` for e2e selectors
 */
import { Link } from "react-router-dom";

export default function VendorNameLink({
  vendor,
  className = "text-blue-600 hover:underline font-medium",
  testIdSuffix = "",
  children,
}) {
  const label = children || vendor?.business_name || vendor?.name || "Vendor";
  const slug = vendor?.public_slug || vendor?.slug;

  if (!slug) {
    return <span className={className.replace(/text-blue-600|hover:underline/g, "").trim() || "text-neutral-700"}>{label}</span>;
  }

  return (
    <Link
      to={`/vendors/${slug}`}
      className={className}
      data-testid={`vendor-name-link${testIdSuffix ? "-" + testIdSuffix : ""}`}
      onClick={(e) => e.stopPropagation()}   // Don't trigger parent card link
    >
      {label}
    </Link>
  );
}
